import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Ajusta esto según la URL base de tu API
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;